export default __webpack_public_path__ + "static/media/select-language.e46230ce.jpg";